export default __webpack_public_path__ + "static/media/wiphala.0b6dbe50.svg";